import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { takeUntil } from 'rxjs/operators';
import { ResultSetConfig } from '../../models/results/result-set-config.model';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'app-result-set-config-btn',
  templateUrl: './result-set-config-btn.component.html',
  styleUrls: ['./result-set-config-btn.component.scss']
})
export class ResultSetConfigBtnComponent extends UserpilotReloader implements OnInit, OnDestroy {
  @Input() resultSetConfig?: ResultSetConfig;
  @Output() toggleChangeNotifier = new EventEmitter();

  onDestroyNotifier = new EventEmitter();
  translationTrigger?: string;

  constructor(private translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit(): void {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((language: string) => {
        this.translationTrigger = language;
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
    this.toggleChangeNotifier.unsubscribe();
  }


  onToggleChange() {
    // no value being emitted, the ngModel will have the value
    this.toggleChangeNotifier.emit();
  }
}
